import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 查询舱位余量
export function queryCabinAllowance(data) {
  return request({
    url: URL.booking.airExport.queryCabinAllowance,
    method: 'post',
    data
  })
}
